import { NotificationType } from '@naturehouse/design-system/components/atoms/notification/Notification';
import UnavailableMethodException from '@naturehouse/nh-essentials/lib/exceptions/UnavailableMethodException';
import type { RequestOptions } from '@naturehouse/nh-essentials/lib/requests/HttpClient';
import type HttpError from '@naturehouse/nh-essentials/lib/requests/HttpError';
import CollectionBase from '../../common/CollectionBase';
import createNotification from '../../util/notification';
import type { PriceListCollectionApiData } from './PriceListCollection.types';

export type PriceListCollectionEndpointParams = {
    houseId: string;
    searchParams: URLSearchParams;
};

export default class HousePriceListCollection extends CollectionBase<
    PriceListCollectionApiData,
    PriceListCollectionEndpointParams
> {
    static #instance: HousePriceListCollection | null = null;

    public static getInstance(): HousePriceListCollection {
        if (this.#instance === null) {
            this.#instance = new HousePriceListCollection();
        }

        return this.#instance;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    private constructor() {
        super();
    }

    public async retrieve<RT>(
        params: PriceListCollectionEndpointParams,
        headers?: RequestOptions['headers'],
        signal?: AbortSignal
    ): Promise<RT | void> {
        return super.retrieve(params, headers, signal);
    }

    public async add(): Promise<void> {
        throw new UnavailableMethodException();
    }

    public async delete(): Promise<void> {
        throw new UnavailableMethodException();
    }

    public async update(): Promise<void> {
        throw new UnavailableMethodException();
    }

    protected endpoint(params: PriceListCollectionEndpointParams): string {
        if (!params.houseId || !params.searchParams) {
            throw new Error('Incorrect parameters');
        }

        return `/api/houses/${params.houseId}/price-list?${params.searchParams}`;
    }

    protected onError(error: HttpError<AjaxResponseError> | undefined): void {
        if (!error?.body) {
            return;
        }

        createNotification(NotificationType.ERROR, error.body.message, 0);
    }
}
